import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CommentAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2H5C3.3 2 2 3.3 2 5V15C2 16.7 3.3 18 5 18H16.6L20.3 21.7C20.7 22.1 21.3 22.1 21.7 21.7C21.9 21.5 22 21.3 22 21V5C22 3.3 20.7 2 19 2Z"
      fill="currentColor"
    />
  </svg>
)

export default CommentAlt
